export default __webpack_public_path__ + "static/studycafe-firenze2-42c7553ebb68b7f7ae295969541a65e8.jpg";